const contact_overlay = () => {
    $('.mobile-menu--contact').on('click', function (e) {
        e.preventDefault();
        if ($(this).hasClass('mobile-menu--contact-open')) {
            $(this).removeClass('mobile-menu--contact-open');
            $('.mobile-menu__phone-icon').fadeIn();
            $('.mobile-menu__close-icon').hide();
            $('.contact-overlay-wrap').slideUp();
        } else {
            $(this).addClass('mobile-menu--contact-open');
            $('.mobile-menu__phone-icon').hide();
            $('.mobile-menu__close-icon').fadeIn();
            $('.contact-overlay-wrap').slideDown();
        }
    });

    // setting dynamic button text based on date and time
    let nowDate = new Date();
    let nowDay = nowDate.getUTCDay();
    let bankHolidayDates = window.bankHolDates;
    let $dynamicButton = $('.contact-overlay__button--dynamic');
    let $desktopContact = $('.secondary-links__contact-top-row');
    let $desktopContactLink = $('.secondary-links__opening-times-link');
    let openingTimes = $('.secondary-links').data('openingtimes');
    var today = getDayName('en-GB')
    var nowTime = getCurrentTime();
    var open = false;
    var closed = true;


    if(openingTimes) {
        openingTimes.forEach((item, index) => {
            var openTime = item.open_time;
            var closeTime = item.close_time;
    
            item.day.forEach((day, dayIndex) => {
                // console.log(day, dayIndex);
    
                if (day === today && isALAOpen(nowTime, openTime, closeTime)) {
                    open = true;
                    closed = false;
                }
            })
        })
    }

    // if sunday or saturday
    if (closed) {
        $dynamicButton.text('Call & leave a message');
        $desktopContact.text('Phone lines closed');
        $desktopContactLink.hide();
    } else {
        let nowDayString = String(nowDate.getDate()).padStart(2, '0');
        let nowMonthString = String(nowDate.getMonth() + 1).padStart(2, '0'); //January is 0!
        let nowYearString = nowDate.getFullYear();
        let nowDateString = nowDayString + '/' + nowMonthString + '/' + nowYearString;

        // if todays date is a bank holiday
        if (!$.inArray(nowDateString, bankHolidayDates) === -1) {
            $dynamicButton.text('Call & leave a message');
            $desktopContact.text('Phone lines closed');
            $desktopContactLink.hide();
        }
    }
}

function getDayName(locale) {
    var date = new Date();
    return date.toLocaleDateString(locale, { weekday: 'long' }).toLowerCase();
}

function getCurrentTime() {
    const date = new Date();

    let timezoneOffset = date.getTimezoneOffset();
    let timezoneOffsetHours = Math.abs(Math.floor(timezoneOffset / 60));
    let timezoneOffsetMinutes = Math.abs(timezoneOffset % 60);
    let hours = date.getHours() // + timezoneOffsetHours;
    let minutes = date.getMinutes() // + timezoneOffsetMinutes;


    let meridiem = hours < 12 ? "am" : "pm";

    // Convert hours from 24-hour time to 12-hour time
    hours = hours % 12;
    hours = hours ? hours : 12; // If hours is 0, set it to 12 instead

    // Add a leading zero to minutes if necessary
    minutes = minutes < 10 ? "0" + minutes : minutes;

    // Combine the hours, minutes, and meridiem into a string
    const time = hours + ":" + minutes + " " + meridiem;
    return time;
}

function isALAOpen(currentTime, openingTime, closingTime) {
    const current = convertTimeTo24Hour(currentTime);
    const opening = convertTimeTo24Hour(openingTime);
    const closing = convertTimeTo24Hour(closingTime);
    
    if (current >= opening && current <= closing) {
        return true;
    } else {
        return false;
    }
}

function convertTimeTo24Hour(time) {
    const hours = parseInt(time.split(":")[0]);
    const minutes = parseInt(time.split(":")[1].replace(/[^0-9]/g, ''));
    const meridiem = time.split(" ")[1];

    let militaryHours;

    if (hours === 12) {
        militaryHours = meridiem === "am" ? 0 : 12;
    } else {
        militaryHours = meridiem === "am" ? hours : hours + 12;
    }

    return militaryHours * 100 + minutes;
}
export default contact_overlay;
